import { Link } from 'react-router-dom'
import { useAuthStore } from '@personic/shared'

export default function Suspended() {
  const { logout } = useAuthStore()

  const handleLogout = () => {
    logout()
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
          <Link to="/" className="flex items-center">
            <span className="text-xl font-bold text-personic-600">Personic AI</span>
          </Link>
          <button
            onClick={handleLogout}
            className="text-sm text-gray-600 hover:text-gray-900"
          >
            Log out
          </button>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center px-4">
        <div className="max-w-md w-full text-center">
          {/* Icon */}
          <div className="mb-8">
            <div className="w-24 h-24 bg-red-100 rounded-full flex items-center justify-center mx-auto">
              <svg className="w-12 h-12 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
          </div>

          {/* Content */}
          <h1 className="text-2xl font-bold text-gray-900 mb-4">
            Account Suspended
          </h1>

          <p className="text-gray-600 mb-8">
            Your account has been temporarily suspended. This may be due to a billing issue,
            terms of service violation, or administrative action.
          </p>

          {/* Info Card */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-8">
            <h2 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-4">
              Next Steps
            </h2>
            <ul className="text-left space-y-3 text-gray-600">
              <li className="flex items-start">
                <span className="w-6 h-6 bg-gray-100 rounded-full flex items-center justify-center mr-3 flex-shrink-0 text-sm font-medium text-gray-600">1</span>
                <span>Contact our support team to understand why your account was suspended</span>
              </li>
              <li className="flex items-start">
                <span className="w-6 h-6 bg-gray-100 rounded-full flex items-center justify-center mr-3 flex-shrink-0 text-sm font-medium text-gray-600">2</span>
                <span>Resolve any outstanding issues (e.g., update payment method)</span>
              </li>
              <li className="flex items-start">
                <span className="w-6 h-6 bg-gray-100 rounded-full flex items-center justify-center mr-3 flex-shrink-0 text-sm font-medium text-gray-600">3</span>
                <span>Request account reactivation once issues are resolved</span>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <a
              href="mailto:support@personicai.com"
              className="btn btn-primary w-full inline-flex items-center justify-center"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              Contact Support
            </a>
            <p className="text-sm text-gray-500">
              Or email us directly at{' '}
              <a href="mailto:support@personicai.com" className="text-personic-600 hover:underline">
                support@personicai.com
              </a>
            </p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-6 text-center text-sm text-gray-500">
        &copy; {new Date().getFullYear()} Personic AI. All rights reserved.
      </footer>
    </div>
  )
}
